import {
  BaseEndpointBuilder,
  endpointBuilder,
} from '@squareup/dex-data-shared-base-api';
import {
  GetApiEventDetailsInput,
  GetApiEventDetailsResponse,
  GetApiEventsResponse,
  GetEventsInput,
  GetWebhookEventsResponse,
} from '@squareup/dex-types-shared-api-webhook-logs';
import { convertKeysToCamelCase } from '@squareup/dex-utils-shared-object-key-utils';

import { DEVELOPER_API_REDUCER_PATH } from './developer-api-constants';
import { DeveloperApiTagTypes } from './developer-api-tag-types';

const LOG_INSPECTOR_API_URL = '/api/metrics';
const appName = 'log-inspector';

const logInspectorEndpointFactory = (
  builder: BaseEndpointBuilder<typeof DEVELOPER_API_REDUCER_PATH>
) => ({
  getApiEvents: builder.query<GetApiEventsResponse, GetEventsInput>({
    query: ({ client_id, limit, start_time, sandbox }: GetEventsInput) => {
      const path = `${LOG_INSPECTOR_API_URL}/api-events`;
      const query = new URLSearchParams();

      if (client_id) {
        query.set('client_id', client_id);
      }

      if (limit) {
        query.set('limit', limit.toString());
      }

      if (start_time) {
        query.set('start_time', start_time);
      }

      if (sandbox) {
        query.set('sandbox', sandbox.toString());
      }

      return {
        path: `${path}?${query.toString()}`,
        appName,
      };
    },
    transformResponse: (response) => {
      return convertKeysToCamelCase(response);
    },
    providesTags: [DeveloperApiTagTypes.ApiEvents],
  }),

  getApiEventDetails: builder.query<
    GetApiEventDetailsResponse,
    GetApiEventDetailsInput
  >({
    query: ({ client_id, id }: GetApiEventDetailsInput) => ({
      path: `${LOG_INSPECTOR_API_URL}/api-events/details/${id}?client_id=${client_id}`,
      appName,
    }),
    transformResponse: (response) => {
      return convertKeysToCamelCase(response);
    },
    providesTags: [DeveloperApiTagTypes.ApiEvents],
  }),

  getWebhookEvents: builder.query<GetWebhookEventsResponse, GetEventsInput>({
    query: ({ client_id, limit, start_time, sandbox }: GetEventsInput) => {
      const path = `${LOG_INSPECTOR_API_URL}/webhook-events`;
      const query = new URLSearchParams();

      if (client_id) {
        query.set('client_id', client_id);
      }

      if (limit) {
        query.set('limit', limit.toString());
      }

      if (start_time) {
        query.set('start_time', start_time);
      }

      if (sandbox) {
        query.set('sandbox', sandbox.toString());
      }

      return {
        path: `${path}?${query.toString()}`,
        appName,
      };
    },
    transformResponse: (response) => {
      return convertKeysToCamelCase(response);
    },
    providesTags: [DeveloperApiTagTypes.WebhookEvents],
  }),
});

const logInspectorEndpoints = logInspectorEndpointFactory(endpointBuilder);

export { logInspectorEndpointFactory, logInspectorEndpoints };
